import http from "@/shared/axios-config/g-http-metodos";

function GetOrcamentoProdutoAtivos(){
    const { res, erro, requisicao } = http.getArray("OrcamentoProduto/GetAtivos");
    return { OrcamentoProdutoArray: res, erro, requisicao }
}


const OrcamentoProdutoController = {
    GetOrcamentoProdutoAtivos
}

export default OrcamentoProdutoController

